import { useCallback, useState } from 'react'
import { faUpload, faTrashCan } from '@fortawesome/pro-regular-svg-icons'
import {
  LabelDescription,
  LabelDescriptionProps,
} from '../BaseComponents/Input'
import { Button, Icon, IconButton, Link, Text } from '../BaseComponents'
import FileUploadModal from './FileUploadModal'
import { useReselector } from '../../utils/sharedHooks'
import { selectUserDocumentCategoryByInternalName } from '@/features/admin/user-document-categories/userDocumentCategories.selectors'
import { getUserDocumentsByCategoryInternalName } from '@/features/user/your-practice/documents/lib/userDocuments.selector'
import { UploadDocumentType } from '../../constants/businessConstants'
import { destroySingleUserDocument } from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import { useAppDispatch } from '../../utils/typeHelpers'
import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

// may potentially be replaced by /profile/your-business/UploadItem comp
// Used for forms but doesn't use formik so doesn't belong in form inputs
const FileUploadFormInput = ({
  documentCat,
  documentType = UploadDocumentType.TAX,
  taxYear,
  hideUploadIfDocs = true,
  uploadedDocsLabel,
  ...rest
}: LabelDescriptionProps & {
  documentCat?: UserDocumentCategoryIdentifier
  documentType?: UploadDocumentType
  taxYear?: string
  hideUploadIfDocs?: boolean
  uploadedDocsLabel?: string
}) => {
  const dispatch = useAppDispatch()
  const [modelOpen, setModalOpen] = useState(false)

  const taxDocCat = useReselector(
    selectUserDocumentCategoryByInternalName,
    documentCat
  )

  const userDocs = useReselector(
    getUserDocumentsByCategoryInternalName,
    documentCat
  )

  const deleteFile = useCallback(
    async (fileId: number) => {
      await destroySingleUserDocument(fileId)(dispatch)
    },
    [dispatch]
  )

  return (
    <>
      <LabelDescription {...rest} />

      {taxDocCat && (!hideUploadIfDocs || !userDocs.length) && (
        <Button
          variant="secondary"
          onClick={() => setModalOpen(true)}
          style={{ width: 150 }}
        >
          <Icon icon={faUpload} size="1x" style={{ marginRight: 10 }} />
          Upload
        </Button>
      )}

      <br />
      {Boolean(uploadedDocsLabel && userDocs.length) && (
        <Text as="eyebrow">{uploadedDocsLabel}</Text>
      )}
      {userDocs.map((doc) => (
        <div key={doc.id}>
          {doc?.signedUrl ? (
            <Link href={doc.signedUrl}>{doc?.fileDescription}</Link>
          ) : (
            <Text>{doc?.fileDescription}</Text>
          )}
          <IconButton
            icon={faTrashCan}
            onClick={() => deleteFile(doc.id)}
            style={{ marginLeft: 10 }}
            color="green"
          />
        </div>
      ))}

      <FileUploadModal
        open={modelOpen}
        close={() => setModalOpen(false)}
        userFacing
        documentType={documentType}
        categoryId={taxDocCat?.id}
        year={taxYear}
      />
    </>
  )
}

export default FileUploadFormInput
